import { getFormValues } from "redux-form";

export const getModalFormValues = (state, formName) =>
  getFormValues(formName)(state);
